import InfoIcon from "@mui/icons-material/Info";
import FormControl from "@mui/material/FormControl";
import { useCallback, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import IconButton from "../../core/components/IconButton.tsx";
import "../Select/Select.css";
import "../SelectEmbarqueV2/SelectEmbarqueV2.css";

function SelectEmbarqueV2(props) {
	const [dadosFiltrados, setDadosFiltrados] = useState([]);

	const [atual, setAtual] = useState();

	const filtra = useCallback(() => {
		var dadosfiltra = props.dadosSelect;
		dadosfiltra?.sort(function (a, b) {
			if (
				a.cidade < b.cidade ||
				a.nome < b.nome ||
				a.nomeFantasia < b.nomeFantasia
			) {
				return -1;
			} else {
				return true;
			}
		});
		setDadosFiltrados(dadosfiltra);
	}, [props.dadosSelect]);

	useEffect(() => {
		filtra();
		if (props.value) {
			setAtual(props.value.value);
		}
	}, [filtra, props.value]);

	const customStyles = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
			zIndex: 999,
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
			zIndex: 999,
		}),
	};

	const customStylesErro = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid red",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const customStylesGrande = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const customStylesGrandeErro = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid red",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const dadosOrdenados = useMemo(() => {
		return dadosFiltrados
			?.map((item) => ({
				value: item[props.referenciaId],
				label: props.referenciaItem2
					? item[props.referenciaItem][props.referenciaItem2]
					: item[props.referenciaItem],
				id: item[props.id],
			}))
			.slice(0, 15);
	}, [
		dadosFiltrados,
		props.referenciaId,
		props.referenciaItem,
		props.referenciaItem2,
	]);

	const handleChange = (option) => {
		setAtual(option.value);
		props.onChange(option);
	};

	const handleInputChange = useCallback(
		(inputValue) => {
			const normalizedInput = inputValue?.trim().toLowerCase();

			if (normalizedInput === "" || !normalizedInput || !props.referenciaItem) {
				setDadosFiltrados(props.dadosSelect);
				return;
			}

			const filteredOptions = props.dadosSelect.filter((option) => {
				const label = props.referenciaItem2
                    ? option[props.referenciaItem]?.[props.referenciaItem2]
                    : option[props.referenciaItem];
				return label?.toLowerCase().includes(normalizedInput);
			});

			setDadosFiltrados(filteredOptions);
		},
		[props.dadosSelect, props.referenciaItem, props.referenciaItem2]
	);

	const formatOptionLabel = ({ label, value, id }) => (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				width: "100%",
				justifyContent: "space-between",
			}}
		>
			{label}
			{atual !== value && !props.infoe && (
				<InfoIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						setTimeout(() => {
							props.onInfoIconClick(id);
							props.onClick(e);
						}, 0);
					}}
				/>
			)}
			{atual === value && !props.info && (
				<div
					style={{
						position: "absolute",
						right: "5px",
					}}
				>
					<IconButton
						icon="X"
						size="md"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							props.clearSelection();
							setAtual(null);
						}}
						backgroundColor="rgba(0, 0, 0, 0)"
						theme="dark"
					/>
				</div>
			)}
		</div>
	);

	return (
		<div className="principal-select">
			<FormControl sx={{ width: props.classeCss ? props.classeCss : 250 }}>
				{!props.erro ? (
					<Select
						value={props.value}
						onChange={handleChange}
						styles={props.grande ? customStylesGrande : customStyles}
						options={dadosOrdenados}
						onInputChange={handleInputChange}
						isDisabled={props.disabled}
						formatOptionLabel={formatOptionLabel}
						placeholder="Selecione"
						noOptionsMessage={() => "Não há mais opções"}
						isMulti={props.multi}
					/>
				) : (
					<Select
						value={props.value}
						onChange={handleChange}
						styles={props.grande ? customStylesGrandeErro : customStylesErro}
						options={dadosOrdenados}
						isDisabled={props.disabled}
						formatOptionLabel={formatOptionLabel}
						placeholder="Selecione"
						noOptionsMessage={() => "Não há mais opções"}
						isMulti={props.multi}
					/>
				)}
			</FormControl>
		</div>
	);
}

export default SelectEmbarqueV2;
